export default __webpack_public_path__ + "static/media/AceLogoFull.17819802.png";